function getGapForIndex({
  gaps,
  direction,
  seriesIndex
}) {
  var _gaps$direction$find$, _gaps$direction$find;
  return (_gaps$direction$find$ = (_gaps$direction$find = gaps[direction].find(({
    index
  }) => index === seriesIndex)) === null || _gaps$direction$find === void 0 ? void 0 : _gaps$direction$find.gap) !== null && _gaps$direction$find$ !== void 0 ? _gaps$direction$find$ : 0;
}

export { getGapForIndex };
